import type React from 'react';
import { lazy, Suspense } from 'react';
import { PageLoading } from '@/app/components/page-loading.tsx';
import { useAuth } from '@/app/hooks/auth-provider';
import { UserTypeEnum } from '../../types/user-type.ts';

const LazyRepMeetingConfirmFoodCategory = lazy(() => import('./RepMeetingConfirmFoodCategory.tsx'));

const RepMeetingConfirmFoodCategory = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => {
  const { user } = useAuth();
  return (
    <Suspense fallback={<PageLoading />}>
      {user?.userType === UserTypeEnum.DrugRep && <LazyRepMeetingConfirmFoodCategory {...props} />}
    </Suspense>
  );
};

export const repMeetingConfirmFoodCategoryRoute = {
  path: '/confirm-meeting-food-category/:key',
  element: <RepMeetingConfirmFoodCategory />,
};

export default RepMeetingConfirmFoodCategory;
